/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { ApiImages, ApiImagesFromJSON, ApiImagesFromJSONTyped, ApiImagesToJSON } from './ApiImages';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';
import { ApiLink, ApiLinkFromJSON, ApiLinkFromJSONTyped, ApiLinkToJSON } from './ApiLink';
import {
  ApiPromotion,
  ApiPromotionFromJSON,
  ApiPromotionFromJSONTyped,
  ApiPromotionToJSON,
} from './ApiPromotion';

/**
 *
 * @export
 * @interface ApiProduct
 */
export interface ApiProduct {
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  accessibilityPromoTermDetails?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  advertisedPrice?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  autoShipDiscountPercentage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  autoShipPrice?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  bundle: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  customizable: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  deliveryMessage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  desktopPromoTermDetailsUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  id?: string;
  /**
   *
   * @type {ApiImages}
   * @memberof ApiProduct
   */
  images?: ApiImages;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  inStock: boolean;
  /**
   *
   * @type {ApiInstrumentation}
   * @memberof ApiProduct
   */
  instrumentation?: ApiInstrumentation;
  /**
   *
   * @type {ApiLink}
   * @memberof ApiProduct
   */
  link?: ApiLink;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  manufacturerName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  mobilePromoTermDetailsUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  monetized: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  onSpecial: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  parentPartNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  partNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  pharmaceutical: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  promoHeadlineLong?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  promoHeadlineShort?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  promoIcon: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  promoMessage?: string;
  /**
   *
   * @type {Array<ApiPromotion>}
   * @memberof ApiProduct
   */
  promotions?: Array<ApiPromotion>;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  proprietary: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiProduct
   */
  rating?: number;
  /**
   *
   * @type {number}
   * @memberof ApiProduct
   */
  ratingCount?: number;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  strikeThroughPrice?: string;
  /**
   *
   * @type {string}
   * @memberof ApiProduct
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiProduct
   */
  veterinaryDiet: boolean;
}

export function ApiProductFromJSON(json: any): ApiProduct {
  return ApiProductFromJSONTyped(json, false);
}

export function ApiProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiProduct {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    accessibilityPromoTermDetails: !exists(json, 'accessibilityPromoTermDetails')
      ? undefined
      : json['accessibilityPromoTermDetails'],
    advertisedPrice: !exists(json, 'advertisedPrice') ? undefined : json['advertisedPrice'],
    autoShipDiscountPercentage: !exists(json, 'autoShipDiscountPercentage')
      ? undefined
      : json['autoShipDiscountPercentage'],
    autoShipPrice: !exists(json, 'autoShipPrice') ? undefined : json['autoShipPrice'],
    bundle: json['bundle'],
    customizable: json['customizable'],
    deliveryMessage: !exists(json, 'deliveryMessage') ? undefined : json['deliveryMessage'],
    desktopPromoTermDetailsUrl: !exists(json, 'desktopPromoTermDetailsUrl')
      ? undefined
      : json['desktopPromoTermDetailsUrl'],
    id: !exists(json, 'id') ? undefined : json['id'],
    images: !exists(json, 'images') ? undefined : ApiImagesFromJSON(json['images']),
    inStock: json['inStock'],
    instrumentation: !exists(json, 'instrumentation')
      ? undefined
      : ApiInstrumentationFromJSON(json['instrumentation']),
    link: !exists(json, 'link') ? undefined : ApiLinkFromJSON(json['link']),
    manufacturerName: !exists(json, 'manufacturerName') ? undefined : json['manufacturerName'],
    mobilePromoTermDetailsUrl: !exists(json, 'mobilePromoTermDetailsUrl')
      ? undefined
      : json['mobilePromoTermDetailsUrl'],
    monetized: json['monetized'],
    onSpecial: json['onSpecial'],
    parentPartNumber: !exists(json, 'parentPartNumber') ? undefined : json['parentPartNumber'],
    partNumber: !exists(json, 'partNumber') ? undefined : json['partNumber'],
    pharmaceutical: json['pharmaceutical'],
    productName: !exists(json, 'productName') ? undefined : json['productName'],
    promoHeadlineLong: !exists(json, 'promoHeadlineLong') ? undefined : json['promoHeadlineLong'],
    promoHeadlineShort: !exists(json, 'promoHeadlineShort')
      ? undefined
      : json['promoHeadlineShort'],
    promoIcon: json['promoIcon'],
    promoMessage: !exists(json, 'promoMessage') ? undefined : json['promoMessage'],
    promotions: !exists(json, 'promotions')
      ? undefined
      : (json['promotions'] as Array<any>).map(ApiPromotionFromJSON),
    proprietary: json['proprietary'],
    rating: !exists(json, 'rating') ? undefined : json['rating'],
    ratingCount: !exists(json, 'ratingCount') ? undefined : json['ratingCount'],
    strikeThroughPrice: !exists(json, 'strikeThroughPrice')
      ? undefined
      : json['strikeThroughPrice'],
    type: json['type'],
    veterinaryDiet: json['veterinaryDiet'],
  };
}

export function ApiProductToJSON(value?: ApiProduct | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    accessibilityPromoTermDetails: value.accessibilityPromoTermDetails,
    advertisedPrice: value.advertisedPrice,
    autoShipDiscountPercentage: value.autoShipDiscountPercentage,
    autoShipPrice: value.autoShipPrice,
    bundle: value.bundle,
    customizable: value.customizable,
    deliveryMessage: value.deliveryMessage,
    desktopPromoTermDetailsUrl: value.desktopPromoTermDetailsUrl,
    id: value.id,
    images: ApiImagesToJSON(value.images),
    inStock: value.inStock,
    instrumentation: ApiInstrumentationToJSON(value.instrumentation),
    link: ApiLinkToJSON(value.link),
    manufacturerName: value.manufacturerName,
    mobilePromoTermDetailsUrl: value.mobilePromoTermDetailsUrl,
    monetized: value.monetized,
    onSpecial: value.onSpecial,
    parentPartNumber: value.parentPartNumber,
    partNumber: value.partNumber,
    pharmaceutical: value.pharmaceutical,
    productName: value.productName,
    promoHeadlineLong: value.promoHeadlineLong,
    promoHeadlineShort: value.promoHeadlineShort,
    promoIcon: value.promoIcon,
    promoMessage: value.promoMessage,
    promotions:
      value.promotions === undefined
        ? undefined
        : (value.promotions as Array<any>).map(ApiPromotionToJSON),
    proprietary: value.proprietary,
    rating: value.rating,
    ratingCount: value.ratingCount,
    strikeThroughPrice: value.strikeThroughPrice,
    type: value.type,
    veterinaryDiet: value.veterinaryDiet,
  };
}
